import React from 'react'
import BackIcon from '../images/back.svg'
import { useNavigate } from 'react-router-dom'

export default function Header({title,RightContent}) {
  const navigate = useNavigate()
  return (
    <div className='flex-[0_0_auto] px-2 py-2 md:px-6 md:py-4 bg-white flex justify-between items-center'>
        <div className='flex items-center'>
          <div className='bg-gray-200 w-6 h-6 md:w-6 md:h-6 rounded-3xl p-2 mr-2 flex items-center justify-center cursor-pointer' onClick={()=>navigate(-1)}>
            <img src={BackIcon} className='w-3 h-3 md:w-3 md:h-3'/>
          </div>
          <h2 className='title-md md:text-lg font-extrabold capitalize tracking-[-.15px] my-2 md:my-3 md:whitespace-nowrap'>{title}</h2>
        </div>
        <RightContent/>
    </div>
  )
}
